module.exports = __webpack_public_path__ + "static/step-1-73c5b6dd6ff579732741d4605a35808d.png";